import { Component, OnInit, Input } from '@angular/core';
import { MatError } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-field-error-display',
    templateUrl: './field-error-display.component.html',
    styleUrls: ['./field-error-display.component.scss'],
    imports: [MatError, TranslateModule]
})
export class FieldErrorDisplayComponent {
  @Input() errorMsg!: string;
  @Input() displayError!: boolean;
  @Input() errorMsgOptions!: any;
}
